// src/reportWebVitals.ts
type PerfEntry = (metric: unknown) => void;

const reportWebVitals = (onPerfEntry?: PerfEntry) => {
    if (typeof onPerfEntry === 'function') {
        import('web-vitals').then(({ onCLS, onFCP, onINP, onLCP, onTTFB }) => {
            onCLS(onPerfEntry);
            onFCP(onPerfEntry);
            onINP(onPerfEntry); // INP replaces FID
            onLCP(onPerfEntry);
            onTTFB(onPerfEntry);
        });
    }
};

export default reportWebVitals;
